/*
 * game-zhongguo-xiangqi.js —— 中国象棋（M5，/study/zhongguo-xiangqi）
 * ---------------------------------------------------------------------------
 * 口径同 game-wuziqi.js：规则 + 引擎 + 界面全在一个文件里（零 vendor、零引擎产物、
 * 零额外请求），暴露 global.STXiangqi 供冒烟与复用直调。交互与讲解样式对齐国象局。
 *
 * 与国际象棋的差异（引擎按正式口径逐一实现）：
 *   马蹩腿、相塞眼且不过河、士帅不出宫、将帅不能照面（王不见王）、
 *   炮隔子打、兵过河才能横走；无子可走判负（困毙不是逼和）、60 回合无吃子判和。
 *
 * 棋盘编码：一维数组 90 格，下标 i = 行 r*9 + 列 c。
 *   r=0 是黑方底线（棋盘上边），r=9 是红方底线（棋盘下边），红在下先行。
 *   棋子整数：正 = 红，负 = 黑；绝对值 1帅/将 2仕/士 3相/象 4马 5车 6炮 7兵/卒。
 * 记谱：中文纵线记法（红方汉字「炮二平五」、黑方阿拉伯数字「马8进7」，
 *   与棋书、教练、象棋软件的通行口径一致）；坐标另附 ICCS 式 a1~i10。
 */
(function (global) {
  'use strict';

  /* ============ 常量 ============ */

  var FILES = 'abcdefghi';
  var CN_NUM = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
  var RED = 1, BLACK = -1;
  var MATE = 100000, INF = 1000000;
  var DRAW_HALF = 120;                     // 60 回合（120 半回合）无吃子判和

  var PIECE_CHAR = {                       // 棋子面上的字（红帅/黑將、黑砲是传统牌面）
    1: '帥', 2: '仕', 3: '相', 4: '馬', 5: '車', 6: '炮', 7: '兵',
    '-1': '將', '-2': '士', '-3': '象', '-4': '馬', '-5': '車', '-6': '砲', '-7': '卒'
  };
  var TYPE_NAME = {                        // 记谱/讲解用简体名（红黑各有叫法）
    1: { 1: '帅', 2: '仕', 3: '相', 4: '马', 5: '车', 6: '炮', 7: '兵' },
    '-1': { 1: '将', 2: '士', 3: '象', 4: '马', 5: '车', 6: '炮', 7: '卒' }
  };
  var TYPE_VALUE = { 1: 0, 2: 110, 3: 110, 4: 400, 5: 900, 6: 450, 7: 80 };  // 子力（兵=100 厘）

  var LEVELS = {
    1: { name: '入门', depth: 2, time: 280 },
    2: { name: '进阶', depth: 3, time: 900 },
    3: { name: '挑战', depth: 4, time: 1800 }
  };

  /* 车/马/炮的分位置表（红方视角，r0=黑方底线；黑方镜像 r→9-r，厘）。
     河沿、卧槽位、卒林车这类「老师傅会说的好点」给正分，窝心与边角给负分。 */
  var PST = {
    4: [0, -4, 0, 0, 0, 0, 0, -4, 0, 18, 26, 30, 34, 40, 34, 30, 26, 18, 18, 32, 47, 48, 60, 48, 47, 32, 18, 8, 26, 40, 47, 55, 47, 40, 26, 8, 4, 20, 36, 44, 48, 44, 36, 20, 4, 2, 16, 30, 38, 44, 38, 30, 16, 2, 4, 12, 22, 30, 34, 30, 22, 12, 4, -2, 8, 14, 20, 22, 20, 14, 8, -2, -6, 0, 4, 8, 10, 8, 4, 0, -6, -10, -6, -4, 0, 0, 0, -4, -6, -10],
    5: [14, 14, 12, 18, 16, 18, 12, 14, 14, 16, 20, 18, 24, 26, 24, 18, 20, 16, 12, 14, 16, 20, 20, 20, 16, 14, 12, 3, 8, 12, 14, 16, 14, 12, 8, 3, 2, 6, 8, 12, 14, 12, 8, 6, 2, 5, 8, 8, 10, 12, 10, 8, 8, 5, 8, 10, 12, 14, 16, 14, 12, 10, 8, 6, 10, 12, 14, 16, 14, 12, 10, 6, 4, 8, 10, 14, 16, 14, 10, 8, 4, 2, 4, 6, 10, 12, 10, 6, 4, 2],
    6: [6, 4, 0, -10, -12, -10, 0, 4, 6, 2, 2, 0, -4, -14, -4, 0, 2, 2, 2, 2, 0, -10, -8, -10, 0, 2, 2, 0, 0, -2, 4, 10, 4, -2, 0, 0, 0, 0, 0, 2, 8, 2, 0, 0, 0, -2, 0, 4, 2, 6, 2, 4, 0, -2, 0, 0, 0, 2, 4, 2, 0, 0, 0, 4, 0, 8, 6, 10, 6, 8, 0, 4, 0, 2, 4, 6, 6, 6, 4, 2, 0, 0, 0, 2, 6, 6, 6, 2, 0, 0]
  };

  /* ============ 棋盘与局面 ============ */

  function startBoard() {
    var b = new Array(90).fill(0);
    var back = [5, 4, 3, 2, 1, 2, 3, 4, 5], c;
    for (c = 0; c < 9; c++) { b[c] = -back[c]; b[81 + c] = back[c]; }
    b[19] = -6; b[25] = -6;      // 黑炮 r2 b/h
    b[64] = 6; b[70] = 6;        // 红炮 r7 b/h
    for (c = 0; c < 9; c += 2) { b[27 + c] = -7; b[54 + c] = 7; }
    return b;
  }

  function newPos() { return { b: startBoard(), turn: RED, half: 0, kr: 85, kb: 4 }; }

  function sign(x) { return x > 0 ? 1 : (x < 0 ? -1 : 0); }
  function inBoard(r, c) { return r >= 0 && r < 10 && c >= 0 && c < 9; }
  function inPalace(color, r, c) {
    if (c < 3 || c > 5) return false;
    return color === RED ? (r >= 7 && r <= 9) : (r >= 0 && r <= 2);
  }
  function ownSide(color, r) { return color === RED ? r >= 5 : r <= 4; }
  function crossed(color, r) { return color === RED ? r <= 4 : r >= 5; }

  // 下标 ↔ ICCS 坐标（a1 = 红方左下角，a10 = 黑方左上角）
  function coordOf(i) { return FILES.charAt(i % 9) + String(10 - ((i / 9) | 0)); }
  function coordIndex(s) {
    var c = FILES.indexOf(s.charAt(0)), r = 10 - parseInt(s.slice(1), 10);
    return (c < 0 || r < 0 || r > 9) ? -1 : r * 9 + c;
  }

  /* ============ 走子生成 ============ */

  // 马的 8 个跳位：[dr, dc, 腿dr, 腿dc]（腿贴着马、沿两格方向）
  var HORSE_STEPS = [
    [-2, -1, -1, 0], [-2, 1, -1, 0], [2, -1, 1, 0], [2, 1, 1, 0],
    [-1, -2, 0, -1], [1, -2, 0, -1], [-1, 2, 0, 1], [1, 2, 0, 1]
  ];
  var DIR4 = [[-1, 0], [1, 0], [0, -1], [0, 1]];
  var DIAG4 = [[-1, -1], [-1, 1], [1, -1], [1, 1]];
  var ELE4 = [[-2, -2], [-2, 2], [2, -2], [2, 2]];

  function genPseudo(b, color, out) {
    out.length = 0;
    for (var i = 0; i < 90; i++) {
      var p = b[i];
      if (!p || sign(p) !== color) continue;
      var t = p * color, r = (i / 9) | 0, c = i % 9, j, d, nr, nc, q;
      if (t === 1) {                       // 帅/将：宫内直行一步
        for (j = 0; j < 4; j++) {
          nr = r + DIR4[j][0]; nc = c + DIR4[j][1];
          if (inPalace(color, nr, nc) && sign(b[nr * 9 + nc]) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
        }
      } else if (t === 2) {                // 仕/士：宫内斜行一步
        for (j = 0; j < 4; j++) {
          nr = r + DIAG4[j][0]; nc = c + DIAG4[j][1];
          if (inPalace(color, nr, nc) && sign(b[nr * 9 + nc]) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
        }
      } else if (t === 3) {                // 相/象：田字、塞象眼、不过河
        for (j = 0; j < 4; j++) {
          d = ELE4[j]; nr = r + d[0]; nc = c + d[1];
          if (!inBoard(nr, nc) || !ownSide(color, nr)) continue;
          if (b[(r + d[0] / 2) * 9 + (c + d[1] / 2)] !== 0) continue;
          if (sign(b[nr * 9 + nc]) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
        }
      } else if (t === 4) {                // 马：日字、蹩马腿
        for (j = 0; j < 8; j++) {
          d = HORSE_STEPS[j];
          if (b[(r + d[2]) * 9 + (c + d[3])] !== 0) continue;
          nr = r + d[0]; nc = c + d[1];
          if (inBoard(nr, nc) && sign(b[nr * 9 + nc]) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
        }
      } else if (t === 5) {                // 车：直线畅通
        for (j = 0; j < 4; j++) {
          d = DIR4[j]; nr = r + d[0]; nc = c + d[1];
          while (inBoard(nr, nc)) {
            q = b[nr * 9 + nc];
            if (q === 0) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
            else { if (sign(q) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 }); break; }
            nr += d[0]; nc += d[1];
          }
        }
      } else if (t === 6) {                // 炮：平移如车，吃子隔一个炮架
        for (j = 0; j < 4; j++) {
          d = DIR4[j]; nr = r + d[0]; nc = c + d[1];
          var screened = false;
          while (inBoard(nr, nc)) {
            q = b[nr * 9 + nc];
            if (!screened) {
              if (q === 0) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
              else screened = true;
            } else if (q !== 0) {
              if (sign(q) !== color) out.push({ f: i, t: nr * 9 + nc, cap: 0 });
              break;
            }
            nr += d[0]; nc += d[1];
          }
        }
      } else if (t === 7) {                // 兵/卒：过河前只进，过河后可横
        nr = r + (color === RED ? -1 : 1);
        if (inBoard(nr, c) && sign(b[nr * 9 + c]) !== color) out.push({ f: i, t: nr * 9 + c, cap: 0 });
        if (crossed(color, r)) {
          if (c > 0 && sign(b[r * 9 + c - 1]) !== color) out.push({ f: i, t: r * 9 + c - 1, cap: 0 });
          if (c < 8 && sign(b[r * 9 + c + 1]) !== color) out.push({ f: i, t: r * 9 + c + 1, cap: 0 });
        }
      }
    }
    return out;
  }

  /* ============ 攻击判定（将军 / 悬子共用，含蹩腿塞眼等全部限制） ============ */

  function attacked(b, sq, by) {
    var r = (sq / 9) | 0, c = sq % 9, i, nr, nc, p, d, blocked;
    // 兵：红兵向上吃（r+1 处的红兵打得到），过河兵横吃
    if (by === RED) {
      if (r < 9 && b[sq + 9] === 7) return true;
      if (crossed(RED, r)) {
        if (c > 0 && b[sq - 1] === 7) return true;
        if (c < 8 && b[sq + 1] === 7) return true;
      }
    } else {
      if (r > 0 && b[sq - 9] === -7) return true;
      if (crossed(BLACK, r)) {
        if (c > 0 && b[sq - 1] === -7) return true;
        if (c < 8 && b[sq + 1] === -7) return true;
      }
    }
    // 马：候选马位 + 马腿（腿贴着马）
    for (i = 0; i < 8; i++) {
      d = HORSE_STEPS[i];
      nr = r - d[0]; nc = c - d[1];
      if (!inBoard(nr, nc)) continue;
      if (b[nr * 9 + nc] !== 4 * by) continue;
      if (b[(nr + d[2]) * 9 + (nc + d[3])] !== 0) continue;
      return true;
    }
    // 车 / 炮：四方向扫描（第一个子是敌车，或炮架后是敌炮）
    for (i = 0; i < 4; i++) {
      d = DIR4[i]; nr = r + d[0]; nc = c + d[1]; blocked = false;
      while (inBoard(nr, nc)) {
        p = b[nr * 9 + nc];
        if (!blocked) {
          if (p !== 0) {
            if (p === 5 * by) return true;
            blocked = true;
          }
        } else if (p !== 0) {
          if (p === 6 * by) return true;
          break;
        }
        nr += d[0]; nc += d[1];
      }
    }
    // 帅/将：宫内贴脸一步
    for (i = 0; i < 4; i++) {
      nr = r + DIR4[i][0]; nc = c + DIR4[i][1];
      if (inPalace(by, nr, nc) && b[nr * 9 + nc] === 1 * by) return true;
    }
    // 仕/士：斜贴一步（落点也要在攻方宫内才有意义）
    for (i = 0; i < 4; i++) {
      nr = r + DIAG4[i][0]; nc = c + DIAG4[i][1];
      if (inPalace(by, nr, nc) && b[nr * 9 + nc] === 2 * by) return true;
    }
    // 相/象：田字飞吃（象眼空、落点在攻方半场）
    for (i = 0; i < 4; i++) {
      d = ELE4[i]; nr = r + d[0]; nc = c + d[1];
      if (!inBoard(nr, nc) || !ownSide(by, r)) continue;
      if (b[(r + d[0] / 2) * 9 + (c + d[1] / 2)] !== 0) continue;
      if (b[nr * 9 + nc] === 3 * by) return true;
    }
    return false;
  }

  // 将帅是否照面（同列中间无子）
  function kingsFacing(b, kr, kb) {
    if (kr % 9 !== kb % 9) return false;
    for (var i = Math.min(kr, kb) + 1; i < Math.max(kr, kb); i++) {
      if (b[i] !== 0) return false;
    }
    return true;
  }

  /* ============ 局面操作与合法着法 ============ */

  function applyMove(pos, m) {
    var b = pos.b;
    m.cap = b[m.t];
    m.half0 = pos.half;
    if (b[m.f] === 1) pos.kr = m.t; else if (b[m.f] === -1) pos.kb = m.t;
    b[m.t] = b[m.f]; b[m.f] = 0;
    pos.half = m.cap === 0 ? pos.half + 1 : 0;
    pos.turn = -pos.turn;
    return m;
  }

  function undoMove(pos, m) {
    var b = pos.b;
    b[m.f] = b[m.t]; b[m.t] = m.cap;
    if (b[m.f] === 1) pos.kr = m.f; else if (b[m.f] === -1) pos.kb = m.f;
    pos.turn = -pos.turn;
    pos.half = m.half0;
    return m;
  }

  // 走法对象池：搜索递归各层各借一个 scratch 数组，避免每节点新分配
  var _pool = [], _poolN = 0;

  // 合法着法（走完不被将、将帅不照面）。困毙/将杀在调用方以「无合法着法」统一判。
  function legalMoves(pos) {
    var color = pos.turn, b = pos.b;
    var list = _pool[_poolN] || (_pool[_poolN] = []);
    _poolN++;
    genPseudo(b, color, list);
    var out = [], i, m, bad;
    for (i = 0; i < list.length; i++) {
      m = list[i];
      applyMove(pos, m);
      bad = attacked(b, color === RED ? pos.kr : pos.kb, -color) || kingsFacing(b, pos.kr, pos.kb);
      undoMove(pos, m);
      if (!bad) out.push(m);
    }
    _poolN--;
    return out;
  }

  function inCheck(pos, color) {
    color = color || pos.turn;
    return attacked(pos.b, color === RED ? pos.kr : pos.kb, -color);
  }

  /* ============ 评估（红方视角，正 = 红优） ============ */

  // 快速评估数值：子力 + 分位置 + 兵卒 + 士象护帅（搜索热路径用，零分配）
  function evaluateNum(b) {
    var mat = 0, posn = 0, pawn = 0, safety = 0, advR = 0, advB = 0, eleR = 0, eleB = 0;
    for (var i = 0; i < 90; i++) {
      var p = b[i];
      if (!p) continue;
      var t = p > 0 ? p : -p, r = (i / 9) | 0, c = i % 9;
      if (p > 0) {
        mat += TYPE_VALUE[t];
        if (PST[t]) posn += PST[t][i];
        if (t === 7 && r <= 4) pawn += 40 + (4 - r) * 12 + (r <= 2 && c >= 3 && c <= 5 ? 30 : 0);
        else if (t === 2) advR++;
        else if (t === 3) eleR++;
        else if (t === 1 && r === 9) safety += 20;
      } else {
        mat -= TYPE_VALUE[t];
        if (PST[t]) posn -= PST[t][(9 - r) * 9 + c];
        if (t === 7 && r >= 5) pawn -= 40 + (r - 5) * 12 + (r >= 7 && c >= 3 && c <= 5 ? 30 : 0);
        else if (t === 2) advB++;
        else if (t === 3) eleB++;
        else if (t === 1 && r === 0) safety -= 20;
      }
    }
    safety += (advR + eleR) * 30 - (advB + eleB) * 30;
    return mat + posn + pawn + safety;
  }

  // 完整评估五项（讲解与评估条用）：在快速评估上补「悬子」扫描
  function evaluateParts(pos) {
    var b = pos.b, mat = 0, posn = 0, pawn = 0, safety = 0;
    var advR = 0, advB = 0, eleR = 0, eleB = 0, hangR = 0, hangB = 0;
    for (var i = 0; i < 90; i++) {
      var p = b[i];
      if (!p) continue;
      var t = p > 0 ? p : -p, r = (i / 9) | 0, c = i % 9;
      if (p > 0) {
        mat += TYPE_VALUE[t];
        if (PST[t]) posn += PST[t][i];
        if (t === 7 && r <= 4) pawn += 40 + (4 - r) * 12 + (r <= 2 && c >= 3 && c <= 5 ? 30 : 0);
        else if (t === 2) advR++;
        else if (t === 3) eleR++;
        else if (t === 1 && r === 9) safety += 20;
        else if (t !== 1 && attacked(b, i, BLACK) && !attacked(b, i, RED)) { hangR += TYPE_VALUE[t]; }
      } else {
        mat -= TYPE_VALUE[t];
        if (PST[t]) posn -= PST[t][(9 - r) * 9 + c];
        if (t === 7 && r >= 5) pawn -= 40 + (r - 5) * 12 + (r >= 7 && c >= 3 && c <= 5 ? 30 : 0);
        else if (t === 2) advB++;
        else if (t === 3) eleB++;
        else if (t === 1 && r === 0) safety -= 20;
        else if (t !== 1 && attacked(b, i, RED) && !attacked(b, i, BLACK)) { hangB += TYPE_VALUE[t]; }
      }
    }
    safety += (advR + eleR) * 30 - (advB + eleB) * 30;
    var threats = (hangB - hangR) * 0.55;   // 对方悬的子是自己的潜在收益
    return {
      material: mat, position: posn, pawns: pawn, kingSafety: safety, threats: threats,
      hangRed: hangR, hangBlack: hangB,
      total: mat + posn + pawn + safety + threats
    };
  }

  function evalFor(pos) { return evaluateNum(pos.b) * pos.turn; }

  /* ============ 搜索：negamax + α-β + 吃子静态延伸 + 迭代加深限时 ============ */

  function orderMoves(pos, moves) {
    var b = pos.b;
    for (var i = 0; i < moves.length; i++) {
      var m = moves[i];
      m.ord = m.cap ? 1000 + TYPE_VALUE[m.cap > 0 ? m.cap : -m.cap] * 10
        - TYPE_VALUE[b[m.f] > 0 ? b[m.f] : -b[m.f]] / 10 : 0;
    }
    moves.sort(function (a, c) { return c.ord - a.ord; });
  }

  function quiesce(pos, alpha, beta, qd, ctx) {
    ctx.nodes++;
    if ((ctx.nodes & 511) === 0 && Date.now() > ctx.deadline) { ctx.abort = true; return alpha; }
    var stand = evalFor(pos);
    if (stand >= beta) return beta;
    if (stand > alpha) alpha = stand;
    if (qd >= 6 || ctx.abort) return alpha;
    var moves = legalMoves(pos), caps = [];
    for (var i = 0; i < moves.length; i++) { if (moves[i].cap) caps.push(moves[i]); }
    if (!caps.length) return alpha;
    orderMoves(pos, caps);
    for (i = 0; i < caps.length; i++) {
      applyMove(pos, caps[i]);
      var sc = -quiesce(pos, -beta, -alpha, qd + 1, ctx);
      undoMove(pos, caps[i]);
      if (ctx.abort) return alpha;
      if (sc >= beta) return beta;
      if (sc > alpha) alpha = sc;
    }
    return alpha;
  }

  function negamax(pos, depth, alpha, beta, ply, ctx) {
    ctx.nodes++;
    if ((ctx.nodes & 511) === 0 && Date.now() > ctx.deadline) { ctx.abort = true; return evalFor(pos); }
    if (pos.half >= DRAW_HALF) return 0;                    // 60 回合无吃子：双方都不亏
    if (depth <= 0) return quiesce(pos, alpha, beta, 0, ctx);
    var moves = legalMoves(pos);
    if (!moves.length) return -(MATE - ply);                // 将杀与困毙同判：无子可走即负
    orderMoves(pos, moves);
    for (var i = 0; i < moves.length; i++) {
      applyMove(pos, moves[i]);
      var sc = -negamax(pos, depth - 1, -beta, -alpha, ply + 1, ctx);
      undoMove(pos, moves[i]);
      if (ctx.abort) return evalFor(pos);
      if (sc >= beta) return beta;
      if (sc > alpha) alpha = sc;
    }
    return alpha;
  }

  // 主入口：迭代加深跑满档位层数（超时则用上一个完整深度的结果），确定性输出。
  // timeMs 可选：复盘页把单局面预算调小（整局 N+1 次搜索是乘法，省的是分钟级），
  // 对战页不传，行为与从前完全一致。
  // 附带 top（≤3 条候选 {san, loss}，loss = 与最佳的差，轮走方视角厘）——
  // 象棋复盘页的「引擎建议 / 备选」直接用，对战页每次 AI 落子多排一次 ≤40 项的序，无感。
  function think(pos, level, timeMs) {
    var opts = LEVELS[level] || LEVELS[2];
    var ctx = { deadline: Date.now() + (typeof timeMs === 'number' && timeMs > 0 ? timeMs : opts.time), nodes: 0, abort: false };
    var root = legalMoves(pos);
    if (!root.length) return null;
    orderMoves(pos, root);
    var best = root[0], bestScore = -INF, finished = 0, lastRound = null;
    for (var depth = 1; depth <= opts.depth; depth++) {
      var curBest = null, curScore = -INF, alpha = -INF;
      var scored = [];
      for (var i = 0; i < root.length; i++) {
        var m = root[i];
        applyMove(pos, m);
        var sc = -negamax(pos, depth - 1, -INF, -alpha, 1, ctx);
        undoMove(pos, m);
        if (ctx.abort) break;
        scored.push({ m: m, sc: sc });
        if (sc > curScore) { curScore = sc; curBest = m; }
        if (sc > alpha) alpha = sc;
      }
      if (ctx.abort) { if (depth === 1 && curBest) { best = curBest; bestScore = curScore; } break; }
      if (curBest) { best = curBest; bestScore = curScore; finished = depth; lastRound = scored; }
    }
    var top = null;
    if (lastRound) {
      lastRound.sort(function (a, b) { return b.sc - a.sc; });
      top = [];
      for (var k = 0; k < lastRound.length && k < 3; k++) {
        top.push({
          san: toChinese(pos.b, lastRound[k].m),
          loss: Math.max(0, Math.round(bestScore - lastRound[k].sc))
        });
      }
    }
    return { move: best, score: bestScore, depth: finished, nodes: ctx.nodes, level: level, top: top };
  }

  /* ---- PV 线（复盘页按需调用）：带 PV 收集的 negamax + 根节点逐着筛选 ----
     剪枝后的线可能不完整——展示用途可接受，如实不冒充「最优证明」。 */
  function pvNegamax(pos, depth, alpha, beta, ply, line, ctx) {
    ctx.nodes++;
    if ((ctx.nodes & 511) === 0 && Date.now() > ctx.deadline) { ctx.abort = true; return evalFor(pos); }
    if (pos.half >= DRAW_HALF) return 0;
    if (depth <= 0) return quiesce(pos, alpha, beta, 0, ctx);
    var moves = legalMoves(pos);
    if (!moves.length) return -(MATE - ply);
    orderMoves(pos, moves);
    var best = -INF, bestLine = null;
    for (var i = 0; i < moves.length; i++) {
      var child = [];
      applyMove(pos, moves[i]);
      var sc = -pvNegamax(pos, depth - 1, -beta, -alpha, ply + 1, child, ctx);
      undoMove(pos, moves[i]);
      if (ctx.abort) return evalFor(pos);
      if (sc > best) { best = sc; bestLine = [toChinese(pos.b, moves[i])].concat(child); }
      if (sc > alpha) alpha = sc;
      if (alpha >= beta) break;
    }
    if (bestLine) { for (var j = 0; j < bestLine.length; j++) line.push(bestLine[j]); }
    return best;
  }

  function pvLine(pos, level) {
    var opts = LEVELS[level] || LEVELS[2];
    var ctx = { deadline: Date.now() + Math.min(opts.time, 600), nodes: 0, abort: false };
    var root = legalMoves(pos);
    if (!root.length) return [];
    orderMoves(pos, root);
    var line = [], bestSc = -INF;
    for (var i = 0; i < root.length; i++) {
      var child = [];
      applyMove(pos, root[i]);
      var sc = -pvNegamax(pos, Math.min(2, opts.depth - 1), -INF, INF, 1, child, ctx);
      undoMove(pos, root[i]);
      if (ctx.abort) break;
      if (sc > bestSc) { bestSc = sc; line = [toChinese(pos.b, root[i])].concat(child); }
    }
    return line;
  }

  function bestMove(pos, level) {
    var r = think(pos, level);
    return r ? r.move : null;
  }

  /* ============ 中文纵线记谱（红汉字 / 黑阿拉伯数字，前中后消歧） ============ */

  function toChinese(b, m) {
    var p = b[m.f], color = p > 0 ? 1 : -1, t = p * color;
    var fr = (m.f / 9) | 0, fc = m.f % 9, tr = (m.t / 9) | 0, tc = m.t % 9;
    var name = TYPE_NAME[color][t];
    var fileChar = color === RED ? CN_NUM[8 - fc] : String(fc + 1);
    var destChar = color === RED ? CN_NUM[8 - tc] : String(tc + 1);
    // 同列同种同色多子 → 前/中/后（红「前」= 更靠近黑方）
    var dup = [], r;
    for (r = 0; r < 10; r++) { if (b[r * 9 + fc] === p) dup.push(r); }
    var prefix = '';
    if (dup.length > 1 && t !== 1) {
      dup.sort(function (a, c) { return color === RED ? a - c : c - a; });
      var idx = dup.indexOf(fr);
      prefix = dup.length === 2 ? (idx === 0 ? '前' : '后')
        : dup.length === 3 ? (idx === 0 ? '前' : (idx === 1 ? '中' : '后'))
        : '第' + (idx + 1);
    }
    var action, amount;
    if (tr === fr) { action = '平'; amount = destChar; }
    else {
      action = (color === RED ? tr < fr : tr > fr) ? '进' : '退';
      amount = (t === 2 || t === 3 || t === 4) ? destChar    // 斜行走子报终点线位
        : (color === RED ? CN_NUM[Math.abs(tr - fr) - 1] : String(Math.abs(tr - fr)));
    }
    return prefix ? prefix + name + action + amount : name + fileChar + action + amount;
  }

  /* ============ 讲解（评估差 → 大白话；与着法同一份数据） ============ */

  function yuan(v) {                       // 厘 → 「约 X.X 个兵」
    var n = Math.round(v / 10) / 10;
    return n === 1 ? '一个兵' : '约 ' + n.toFixed(1) + ' 个兵';
  }

  function annotate(pos, m) {
    var b = pos.b, sg = pos.turn;
    var before = evaluateParts(pos);
    var wasCheck = attacked(b, sg === RED ? pos.kr : pos.kb, -sg);
    var san = toChinese(b, m);
    var p = b[m.f], t = p * sg;
    var crossedBefore = crossed(sg, (m.f / 9) | 0);
    var crossedAfter = crossed(sg, (m.t / 9) | 0);
    var cap = b[m.t];
    applyMove(pos, m);
    var mate = legalMoves(pos).length === 0;
    var check = attacked(pos.b, pos.turn === RED ? pos.kr : pos.kb, -pos.turn);
    var after = evaluateParts(pos);
    undoMove(pos, m);
    var d = {
      material: (after.material - before.material) * sg,
      position: (after.position - before.position) * sg,
      pawns: (after.pawns - before.pawns) * sg,
      kingSafety: (after.kingSafety - before.kingSafety) * sg,
      threats: (after.threats - before.threats) * sg,
      total: (after.total - before.total) * sg
    };
    var phrases = [];
    if (cap) phrases.push('吃掉一个' + TYPE_NAME[-sg][cap > 0 ? cap : -cap] + '，' + yuan(TYPE_VALUE[cap > 0 ? cap : -cap]) + '到手');
    if (mate) phrases.push(check ? '这一手将杀，对方无解' : '走完这手对方无子可动——困毙也判负');
    else if (check) phrases.push('将军，逼对方先应将');
    if (!mate && d.material >= 80) phrases.push('子力赚到' + yuan(d.material));
    if (!mate && d.material <= -80) phrases.push('子力付出' + yuan(-d.material));
    if (t === 7 && !crossedBefore && crossedAfter) phrases.push('兵卒过了河，从此能横着走');
    else if (!mate && d.pawns >= 24) phrases.push('兵卒阵线往前推');
    if (!mate && d.position >= 30) phrases.push('车马炮占的点位更好');
    else if (!mate && d.position <= -30) phrases.push('让出了一个活跃点位');
    if (!mate && d.kingSafety >= 25) phrases.push('士象护帅更稳');
    else if (!mate && d.kingSafety <= -25) phrases.push('自家宫门薄了，要当心');
    if (!mate && d.threats <= -60) phrases.push('有子悬着没人保（' + yuan(-d.threats) + '），接下来要留意');
    if (wasCheck) phrases.push('先解了将，稳住阵脚');
    if (!phrases.length) phrases.push(d.total >= 0 ? '平稳过渡，保持阵型' : '这步略亏，等对方失误');
    return {
      san: san, name: TYPE_NAME[sg][t], color: sg,
      from: coordOf(m.f), to: coordOf(m.t), captured: cap || 0,
      check: check, mate: mate, deltas: d, before: before, after: after, phrases: phrases
    };
  }

  /* ================================================================
     UI（页面存在时才启动；STXiangqi 引擎出口在文件末尾，冒烟可在 node 里直调）
     ================================================================ */

  var STORE_KEY = 'study-zhongguo-xiangqi-game';
  var RECORD_KEY = STORE_KEY + '-record';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var root = null;
  var ui = { board: null, thinking: null, status: null, explain: null, moves: null, saved: null,
    newBtn: null, replayBtn: null, replayLabel: null, undoBtn: null, hintBtn: null, resignBtn: null,
    prevBtn: null, nextBtn: null, exportBtn: null, copyBtn: null, reviewBtn: null, cells: [], evalFill: null, evalNum: null, material: null };

  var S = {
    pos: newPos(),
    moves: [],            // {f, t, san, an}（an = 讲解数据）
    level: 1,
    soundOn: true,
    busy: false,
    ended: false,
    winner: 0,            // 1=你(红) 2=对手(黑) 3=和棋
    resigned: false,
    reviewAt: -1,
    sel: -1,              // 当前选中的红子下标
    selMoves: [],
    hint: null,           // {f, t}
    flyMove: null,        // 最近一手（落点挂 is-fly，直到回看/悔棋等动作清除）
    flyFresh: false,      // 只在落地后的第一次渲染播一次飞子动画
    replayTimer: null
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function sideName(color) { return color === RED ? '红' : '黑'; }
  function pieceName(p) { return sideName(p > 0 ? 1 : -1) + TYPE_NAME[p > 0 ? 1 : -1][p > 0 ? p : -p]; }

  // 前 k 手之后的局面（回看、讲解、恢复统一走重放，内存只存一份当前 pos）
  function boardAt(k) {
    var p = newPos(), i;
    for (i = 0; i < k; i++) applyMove(p, { f: S.moves[i].f, t: S.moves[i].t });
    return p;
  }

  /* ============ 棋盘构建：SVG 网格 + 90 个交叉点按钮 ============ */

  // 炮位/兵（卒）位的「提手」刻痕位置（经典棋盘的开局标记）
  var MARKS = [[2, 1], [2, 7], [3, 0], [3, 2], [3, 4], [3, 6], [3, 8], [6, 0], [6, 2], [6, 4], [6, 6], [6, 8], [7, 1], [7, 7]];

  function svgLine(g, x1, y1, x2, y2, cls) {
    var l = document.createElementNS(SVG_NS, 'line');
    l.setAttribute('x1', x1); l.setAttribute('y1', y1);
    l.setAttribute('x2', x2); l.setAttribute('y2', y2);
    l.setAttribute('class', cls || 'st-xq-line');
    g.appendChild(l);
    return l;
  }

  function buildGrid() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 10 11');
    svg.setAttribute('class', 'st-xq-grid');
    svg.setAttribute('aria-hidden', 'true');
    var g = document.createElementNS(SVG_NS, 'g');
    svg.appendChild(g);
    var r, c, x, y, dx, dy;
    for (r = 0; r < 10; r++) svgLine(g, 1, r + 1, 9, r + 1);          // 10 条横线
    for (c = 0; c < 9; c++) {                                          // 竖线：两条边全高，其余被楚河汉界截断
      x = c + 1;
      if (c === 0 || c === 8) svgLine(g, x, 1, x, 10);
      else { svgLine(g, x, 1, x, 5); svgLine(g, x, 6, x, 10); }
    }
    // 九宫斜线（上下宫各两条）
    svgLine(g, 4, 1, 6, 3); svgLine(g, 6, 1, 4, 3);
    svgLine(g, 4, 8, 6, 10); svgLine(g, 6, 8, 4, 10);
    // 炮位/卒位刻痕
    for (r = 0; r < MARKS.length; r++) {
      x = MARKS[r][1] + 1; y = MARKS[r][0] + 1;
      for (dx = -1; dx <= 1; dx += 2) {
        for (dy = -1; dy <= 1; dy += 2) {
          if ((MARKS[r][1] === 0 && dx < 0) || (MARKS[r][1] === 8 && dx > 0)) continue;
          svgLine(g, x + dx * 0.08, y + dy * 0.08, x + dx * 0.38, y + dy * 0.08, 'st-xq-line st-xq-tick');
          svgLine(g, x + dx * 0.08, y + dy * 0.08, x + dx * 0.08, y + dy * 0.38, 'st-xq-line st-xq-tick');
        }
      }
    }
    // 楚河 汉界：y 是基线，楚河带在 y=5~6 之间，取 5.7 让字在带内视觉居中
    var t1 = document.createElementNS(SVG_NS, 'text');
    t1.setAttribute('x', '2.7'); t1.setAttribute('y', '5.7');
    t1.setAttribute('class', 'st-xq-river'); t1.setAttribute('text-anchor', 'middle');
    t1.textContent = '楚 河';
    var t2 = document.createElementNS(SVG_NS, 'text');
    t2.setAttribute('x', '7.3'); t2.setAttribute('y', '5.7');
    t2.setAttribute('class', 'st-xq-river'); t2.setAttribute('text-anchor', 'middle');
    t2.textContent = '漢 界';
    g.appendChild(t1); g.appendChild(t2);
    return svg;
  }

  function buildBoard() {
    ui.board.textContent = '';
    ui.board.appendChild(buildGrid());
    ui.cells = [];
    for (var i = 0; i < 90; i++) {
      (function (idx) {
        var r = (idx / 9) | 0, c = idx % 9;
        var b = el('button', 'st-xq-pt');
        b.type = 'button';
        b.dataset.sq = coordOf(idx);
        b.style.setProperty('--r', String(r));
        b.style.setProperty('--c', String(c));
        b.appendChild(el('span', 'st-xq-piece'));
        b.addEventListener('click', function () { onPoint(idx); });
        ui.board.appendChild(b);
        ui.cells.push({ el: b, i: idx });
      })(i);
    }
  }

  function cellAt(i) { return ui.cells[i]; }

  /* ============ 渲染 ============ */

  function renderAll() {
    if (ui.thinking) ui.thinking.hidden = !S.busy;
    renderBoard();
    renderState();
    renderExplain();
    renderMoves();
    renderButtons();
  }

  function renderBoard() {
    var view = boardAt(S.reviewAt + 1);
    var cur = S.moves[S.reviewAt] || null;
    var hintOn = !!S.hint && S.reviewAt === S.moves.length - 1;
    var selOn = S.sel >= 0 && S.reviewAt === S.moves.length - 1;
    var kingSq = inCheck(view, view.turn) ? (view.turn === RED ? view.kr : view.kb) : -1;
    // 飞子：标记 = 最近一手且正看到最新局面（对手思考重渲染时保留）；
    // 动画只在落地后的第一次渲染播一次（回看/悔棋不飞，口径同国象）
    var flyOn = !!S.flyMove && S.reviewAt === S.moves.length - 1;
    for (var n = 0; n < ui.cells.length; n++) {
      var c = ui.cells[n], i = c.i;
      var p = view.b[i];
      var span = c.el.firstChild;
      if (p) {
        span.textContent = PIECE_CHAR[p > 0 ? p : -p] || '';
        span.className = 'st-xq-piece ' + (p > 0 ? 'st-xq-red' : 'st-xq-black');
        c.el.classList.add('is-filled');
        c.el.setAttribute('aria-label', pieceName(p) + ' ' + coordOf(i));
      } else {
        span.textContent = '';
        span.className = 'st-xq-piece';
        c.el.classList.remove('is-filled');
        c.el.setAttribute('aria-label', coordOf(i));
      }
      var last = cur && (cur.f === i || cur.t === i);
      c.el.classList.toggle('is-last', !!last);
      c.el.classList.toggle('is-sel', selOn && S.sel === i);
      var isHit = false, isCap = false;
      if (selOn) {
        for (var k = 0; k < S.selMoves.length; k++) {
          if (S.selMoves[k].t === i) { isHit = true; isCap = !!view.b[i]; break; }
        }
      }
      c.el.classList.toggle('is-hit', isHit && !isCap);
      c.el.classList.toggle('is-capture', isHit && isCap);
      c.el.classList.toggle('is-check', i === kingSq);
      c.el.classList.toggle('is-hint', hintOn && (S.hint.f === i || S.hint.t === i));
      c.el.classList.toggle('is-fly', flyOn && i === S.flyMove.t);
      c.el.disabled = S.ended || S.busy;
    }
    if (S.flyFresh && flyOn) {
      flyPiece(S.flyMove.f, S.flyMove.t);
      S.flyFresh = false;
    }
  }

  // 走子轨迹：起点 → 落点的位移 = 两点坐标差 × 一格（棋子宽 = 0.92 格，故按 108.7% 计）
  function flyPiece(from, to) {
    if (!root || global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sq = ui.board.querySelector('[data-sq="' + coordOf(to) + '"]');
    if (!sq) return;
    var piece = sq.querySelector('.st-xq-piece');
    if (!piece) return;
    var dx = (from % 9) - (to % 9), dy = ((from / 9) | 0) - ((to / 9) | 0);
    if (!dx && !dy) return;
    piece.style.transform = 'translate(calc(' + dx + ' * 108.7%), calc(' + dy + ' * 108.7%))';
    sq.className += ' is-fly';
    void sq.offsetWidth;
    piece.className += ' is-fly';
    piece.style.transform = 'none';
  }

  /* ============ 交互与对局流程 ============ */

  function onPoint(i) {
    stopReplay();                                   // 回放中点棋盘 = 停下回最新
    if (S.reviewAt < S.moves.length - 1) {
      S.reviewAt = S.moves.length - 1;
      S.sel = -1; S.selMoves = [];
      S.flyMove = null; S.flyFresh = false;
      renderAll();
      return;
    }
    if (S.busy || S.ended) return;
    var pos = S.pos, p = pos.b[i];
    if (S.sel >= 0) {
      if (i === S.sel) { S.sel = -1; S.selMoves = []; renderAll(); return; }
      for (var k = 0; k < S.selMoves.length; k++) {
        if (S.selMoves[k].t === i) {
          var mv = S.selMoves[k];           // 先取走法再清选中，否则参数求值时已是 undefined
          S.sel = -1; S.selMoves = [];
          playerMove(mv);
          return;
        }
      }
      if (p > 0) selectPiece(i);
      else { S.sel = -1; S.selMoves = []; renderAll(); }
      return;
    }
    if (p > 0) selectPiece(i);
  }

  function selectPiece(i) {
    var all = legalMoves(S.pos), mine = [];
    for (var k = 0; k < all.length; k++) { if (all[k].f === i) mine.push(all[k]); }
    if (!mine.length) {                             // 没有合法走法也亮一下状态，别让页面装死
      var nm = pieceName(S.pos.b[i]);
      ui.status.textContent = nm + '（' + coordOf(i) + '）现在没有合法走法' +
        (S.pos.b[i] === 4 ? '——多半是马腿被蹩了。' : '，换个子走吧。');
      S.sel = -1; S.selMoves = [];
      renderAll();
      return;
    }
    S.sel = i; S.selMoves = mine;
    renderAll();
  }

  // 一手棋的完整落地（人机共用）：讲解 → 应用 → 终局判定 → 存档渲染
  function commitMove(m, byPlayer) {
    var an = annotate(S.pos, m);
    var rec = { f: m.f, t: m.t, san: an.san, an: an };
    applyMove(S.pos, m);
    S.moves.push(rec);
    S.reviewAt = S.moves.length - 1;
    S.hint = null;
    S.flyMove = { f: m.f, t: m.t };
    S.flyFresh = true;
    if (an.mate) {
      S.ended = true;
      S.winner = byPlayer ? 1 : 2;
      bumpRecord(byPlayer ? 'w' : 'l');
    } else if (S.pos.half >= DRAW_HALF) {
      S.ended = true; S.winner = 3;
      bumpRecord('d');
    }
    sfx(byPlayer ? RED : BLACK, an.mate && byPlayer);
    save();
    renderAll();
    return an;
  }

  function playerMove(m) { commitMove(m, true); if (!S.ended) aiMove(); }

  function aiMove() {
    S.busy = true;
    renderAll();
    setTimeout(function () {
      var mv = think(S.pos, S.level);
      S.busy = false;
      if (!mv) { renderAll(); return; }             // 理论上到不了：终局在上一手已判
      commitMove(mv.move, false);
    }, 320 + Math.random() * 320);
  }

  /* ============ 状态行 / 评估条 / 讲解 / 行子表 ============ */

  function resultLine() {
    if (!S.ended) return '未结束';
    if (S.winner === 3) return '和棋（六十回合无吃子）';
    if (S.winner === 1) return '红胜（你）——将杀';
    return S.resigned ? '黑胜（对手）——你认输' : '黑胜（对手）——将杀';
  }

  function renderState() {
    var pos = S.pos;
    // 评估条：以回看到的局面算，五项合计量纲换算成「兵」
    var view = boardAt(S.reviewAt + 1);
    var e = evaluateParts(view);
    var redShare = 100 / (1 + Math.exp(-e.total / 300));
    if (ui.evalFill) ui.evalFill.style.width = redShare.toFixed(1) + '%';
    if (ui.evalNum) {
      var v = e.total / 100;
      ui.evalNum.textContent = (v > 0 ? '+' : '') + v.toFixed(1);
    }
    // 子力小结：数吃掉的都是什么（只算回看到的那一手为止，与评估条同一局面）
    if (ui.material) {
      var diff = 0;
      for (var i = 0; i <= S.reviewAt; i++) {
        var cap = S.moves[i].an && S.moves[i].an.captured;
        if (cap) diff += cap > 0 ? -TYPE_VALUE[cap] : TYPE_VALUE[-cap];
      }
      ui.material.textContent = diff > 50 ? '子力：你（红）多' + yuan(diff)
        : diff < -50 ? '子力：电脑（黑）多' + yuan(-diff)
        : '子力：持平';
    }
    // 状态行
    var t = ui.status;
    t.className = 'st-status';
    if (S.ended) {
      t.classList.add('is-over');
      if (S.winner === 3) t.textContent = '六十回合没有吃子，按和棋算。点「开始新的一局」再来。';
      else if (S.winner === 1) t.textContent = '将杀！这局你赢了。想再来一局就点「开始新的一局」。';
      else if (S.resigned) t.textContent = '你认输了。想回到认输前就点「悔一步」，或者开一局新的。';
      else t.textContent = '被将死了，这局输了。用「悔一步」回到失误前，或点行子列表回看它是从哪一步漏的风。';
      t.textContent += ' ' + recordText();
      return;
    }
    if (S.busy) { t.textContent = '对手正在算这一步……（全部在本地算，没有请求服务器）'; return; }
    if (S.reviewAt < S.moves.length - 1) {
      t.textContent = S.replayTimer
        ? '回放中：第 ' + (S.reviewAt + 1) + ' / ' + S.moves.length + ' 步。再点「停止回放」停在这里。'
        : '正在回看第 ' + (S.reviewAt + 1) + ' / ' + S.moves.length + ' 步。点「下一步」回到最新，或直接点棋盘继续下。';
      return;
    }
    if (inCheck(pos, RED)) t.classList.add('is-warn');
    t.textContent = S.moves.length
      ? '轮到你（红）· 已下 ' + Math.ceil(S.moves.length / 2) + ' 回合' + (inCheck(pos, RED) ? ' · 你正被将军，先解将！' : '')
      : '点棋盘上的红子走子，你执红先行。';
  }

  function renderExplain() {
    var box = ui.explain;
    box.textContent = '';
    box.classList.remove('st-explain--me', 'st-explain--bad');
    if (S.reviewAt < 0) {
      var empty = el('p', 'st-explain-empty');
      empty.appendChild(el('span', '', '对手走完，这里会出现一句它为什么这么走'));
      box.appendChild(empty);
      return;
    }
    var m = S.moves[S.reviewAt];
    if (m.an.color === RED) box.classList.add('st-explain--me');
    if (m.an.color === RED && m.an.deltas.total <= -150) box.classList.add('st-explain--bad');
    var head = el('p', 'st-explain-head',
      '第 ' + (S.reviewAt + 1) + ' 步 · ' + sideName(m.an.color) + m.an.name + ' · ' + m.san);
    var list = el('ul', 'st-explain-list');
    for (var i = 0; i < m.an.phrases.length; i++) list.appendChild(el('li', '', m.an.phrases[i]));
    box.appendChild(head);
    box.appendChild(list);
  }

  function moveTitle(idx) {
    var m = S.moves[idx];
    return (m.an.color === RED ? '你 · ' : '对手 · ') + sideName(m.an.color) + m.an.name + ' ' + m.san
      + '：' + m.an.phrases.join('；');
  }

  function renderMoves() {
    var box = ui.moves;
    box.textContent = '';
    if (!S.moves.length) return;
    var head = el('li', 'st-move-row st-move-row--head');
    head.appendChild(el('span', 'st-move-no', '#'));
    head.appendChild(el('span', 'st-move-col', '你（红）'));
    head.appendChild(el('span', 'st-move-col', '电脑（黑）'));
    box.appendChild(head);
    for (var i = 0; i < S.moves.length; i += 2) {
      var row = el('li', 'st-move-row');
      row.appendChild(el('span', 'st-move-no', (i / 2 + 1) + '.'));
      for (var k = 0; k < 2; k++) {
        var idx = i + k;
        if (idx >= S.moves.length) { row.appendChild(el('span', 'st-move-ply')); continue; }
        var m = S.moves[idx];
        var b = el('button', 'st-move-ply');
        b.type = 'button';
        b.textContent = m.san;
        b.setAttribute('data-ply', String(idx));
        if (S.reviewAt === idx) b.className += ' is-cur';
        b.title = moveTitle(idx);
        (function (ply) {
          b.addEventListener('click', function () {
            stopReplay();
            S.reviewAt = ply;
            S.sel = -1; S.selMoves = []; S.hint = null;
            S.flyMove = null; S.flyFresh = false;
            renderAll();
          });
        })(idx);
        row.appendChild(b);
      }
      box.appendChild(row);
    }
  }

  function renderButtons() {
    var reviewing = S.reviewAt < S.moves.length - 1;
    var replaying = !!S.replayTimer;
    var canUndo = S.moves.length >= 2 && !S.busy && !replaying && (!S.ended || S.winner === 2 || S.winner === 3 || S.resigned);
    ui.newBtn.disabled = false;
    ui.undoBtn.disabled = !canUndo;
    ui.hintBtn.disabled = S.busy || S.ended || reviewing || replaying;
    ui.resignBtn.disabled = S.busy || S.ended || replaying;
    ui.replayBtn.disabled = !S.moves.length || S.busy;
    ui.replayLabel.textContent = replaying ? '停止回放' : '回放这局';
    ui.prevBtn.disabled = S.reviewAt <= 0;
    ui.nextBtn.disabled = !reviewing;
    ui.exportBtn.disabled = !S.moves.length;
    ui.copyBtn.disabled = !S.moves.length;
    ui.reviewBtn.disabled = !S.moves.length || S.busy;
  }

  /* ============ 战绩与存档（全在本机 localStorage） ============ */

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return { w: r.w || 0, l: r.l || 0, d: r.d || 0 };
    } catch (e) { return { w: 0, l: 0, d: 0 }; }
  }

  function bumpRecord(key) {
    var r = loadRecord();
    r[key]++;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(r)); } catch (e) { /* 隐私模式静默 */ }
  }

  function recordText() {
    var r = loadRecord();
    if (!r.w && !r.l && !r.d) return '';
    return '（本机战绩：' + r.w + ' 胜 ' + r.l + ' 负' + (r.d ? ' ' + r.d + ' 和' : '') + '，只存在这台设备）';
  }

  function save() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({
        v: 1, level: S.level, soundOn: S.soundOn,
        moves: S.moves.map(function (m) { return [m.f, m.t]; }),
        resigned: S.resigned, winner: S.winner
      }));
    } catch (e) { /* 存储不可用静默（无痕模式） */ }
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return false;
      var d = JSON.parse(raw);
      if (!d || d.v !== 1 || !d.moves || !d.moves.length) return false;
      S.level = d.level || 1;
      S.soundOn = d.soundOn !== false;
      S.resigned = !!d.resigned;
      S.winner = d.winner || 0;
      S.ended = !!S.winner;
      S.pos = newPos();
      S.moves = [];
      for (var i = 0; i < d.moves.length; i++) {
        var m = { f: d.moves[i][0], t: d.moves[i][1] };
        var an = annotate(S.pos, m);       // 先讲解（拿旧局面算），再落地
        applyMove(S.pos, m);
        an.captured = m.cap || 0;
        S.moves.push({ f: m.f, t: m.t, san: an.san, an: an });
      }
      S.reviewAt = S.moves.length - 1;
      return true;
    } catch (e) { return false; }
  }

  /* ============ 导出与复制 ============ */

  // 本地时间戳（不用 toISOString：那是 UTC，东八区晚 8 点后导出会把日期写成第二天）
  function localStamp(withClock) {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var date = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
    return withClock ? date + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) : date;
  }

  // 文件名时间戳：日期_时分（HHMM 连写，冒号在 Windows 文件名里非法）
  function fileStamp() {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return localStamp(false) + '_' + p(d.getHours()) + p(d.getMinutes());
  }

  // 纯函数（冒烟钩子直调）：中文纵线记谱文本，括号附 ICCS 坐标
  function exportLines(moves, level, result, rec) {
    var lines = [
      '学习乐园 · 中国象棋棋谱',
      '导出时间：' + localStamp(true),
      '记谱：中文纵线记法（红方汉字、黑方数字），括号内是 a1~i10 坐标',
      '对手强度：' + levelName(level),
      '结果：' + result,
      '本机战绩：' + rec.w + ' 胜 ' + rec.l + ' 负 ' + rec.d + ' 和',
      ''
    ];
    for (var i = 0; i < moves.length; i++) {
      lines.push((i + 1) + '. ' + sideName(moves[i].an.color) + moves[i].an.name + ' '
        + moves[i].san + '（' + coordOf(moves[i].f) + '-' + coordOf(moves[i].t) + '）');
    }
    return lines;
  }

  function exportText() {
    var lines = exportLines(S.moves, S.level, resultLine(), loadRecord());
    var text = lines.join('\n') + '\n';
    var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    var name = '学习乐园-中国象棋-' + fileStamp() + '.txt';
    deliverDownload(name, blob);
  }

  function deliverDownload(name, blob) {
    var usable = false;
    try { usable = !!(global.URL && global.URL.createObjectURL); } catch (e) { usable = false; }
    if (!usable) {
      // 无 createObjectURL 的环境（老浏览器/部分内嵌 webview）：留观测桩供冒烟取证
      (global.__xqWrites = global.__xqWrites || []).push({ name: name, blob: blob });
      return;
    }
    var url = global.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    global.__xqLastDownload = name;   // 真链路观测点（jsdom 有 createObjectURL 时冒烟走这里）
    setTimeout(function () { global.URL.revokeObjectURL(url); }, 1000);
  }

  function copyText() {
    var lines = [];
    for (var i = 0; i < S.moves.length; i++) {
      lines.push((i + 1) + '. ' + sideName(S.moves[i].an.color) + S.moves[i].an.name + ' ' + S.moves[i].san);
    }
    var text = '学习乐园 · 中国象棋（' + resultLine() + '）\n' + lines.join('\n');
    var ok = false;
    if (global.ToolUI && global.ToolUI.copy) ok = global.ToolUI.copy(text);
    if (!ok) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
    }
    toast(ok ? '已复制棋谱文本' : '复制失败，请用「导出棋谱」存文件');
  }

  /* 复盘移交：把本局棋谱文本放进 sessionStorage，跳到象棋复盘页自动分析。
     文本与「导出棋谱」同格式（带坐标括号），复盘页解析以坐标为权威。
     sessionStorage 被禁时退回复制，用户手动粘贴一样能复盘。 */
  var HANDOFF_KEY = 'study-zhongguo-xiangqi-fupan-handoff';
  function handoffReview() {
    if (!S.moves.length || S.busy) return;
    var lines = [];
    for (var i = 0; i < S.moves.length; i++) {
      lines.push((i + 1) + '. ' + sideName(S.moves[i].an.color) + S.moves[i].an.name + ' '
        + S.moves[i].san + '（' + coordOf(S.moves[i].f) + '-' + coordOf(S.moves[i].t) + '）');
    }
    var text = '学习乐园 · 中国象棋棋谱\n\n' + lines.join('\n');
    try {
      global.sessionStorage.setItem(HANDOFF_KEY, text);
      /* 跳转路径以模板注入的栏根为准（data-st-base），硬编码 /study 在子路径部署会 404 */
      var base = (root && root.getAttribute('data-st-base')) || '/study';
      global.location.href = base + '/zhongguo-xiangqi-fupan';
      return;
    } catch (e) { /* sessionStorage 被禁：退回复制 */ }
    copyText();
    toast('浏览器不允许中转，棋谱已复制——到复盘页粘贴即可');
  }

  function toast(msg) {
    if (!ui.saved) return;
    ui.saved.textContent = msg;
    ui.saved.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { ui.saved.hidden = true; }, 2200);
  }

  function levelName(lv) { return LEVELS[lv] ? LEVELS[lv].name : '进阶'; }

  /* ============ 音效（WebAudio 本地合成，无音频文件） ============ */

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(color, win) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var freqs = win ? [330, 415, 494] : [color === RED ? 240 : 190];
      for (var i = 0; i < freqs.length; i++) {
        var o = actx.createOscillator();
        var g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && freqs[i] < 500 ? freqs[i] * 2 : freqs[i], t + i * 0.09);
        g.gain.setValueAtTime(0.0001, t + i * 0.09);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.45 : 0.2, t + i * 0.09 + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.09 + (SFX_MOBILE ? 0.19 : 0.13));
        o.connect(g);
        g.connect(actx.destination);
        o.start(t + i * 0.09);
        o.stop(t + i * 0.09 + (SFX_MOBILE ? 0.24 : 0.15));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  /* ============ 回放与对局动作 ============ */

  function stopReplay() {
    if (!S.replayTimer) return;
    clearTimeout(S.replayTimer);
    S.replayTimer = null;
  }

  function replayStep() {
    if (S.reviewAt >= S.moves.length - 1) { S.replayTimer = null; renderAll(); return; }
    S.reviewAt++;
    var done = S.reviewAt >= S.moves.length - 1;
    if (done) S.replayTimer = null;
    renderAll();
    if (!done) S.replayTimer = setTimeout(replayStep, 750);
  }

  function toggleReplay() {
    if (S.busy) return;
    if (S.replayTimer) { stopReplay(); renderAll(); return; }
    if (!S.moves.length) return;
    S.hint = null; S.sel = -1; S.selMoves = [];
    S.flyMove = null; S.flyFresh = false;
    S.reviewAt = -1;
    renderAll();
    S.replayTimer = setTimeout(replayStep, 400);
  }

  function newGame() {
    stopReplay();
    S.pos = newPos();
    S.moves = [];
    S.ended = false;
    S.winner = 0;
    S.resigned = false;
    S.reviewAt = -1;
    S.sel = -1; S.selMoves = [];
    S.hint = null;
    S.flyMove = null;
    S.flyFresh = false;
    S.busy = false;
    save();
    renderAll();
  }

  function undo() {
    if (S.busy) return;
    stopReplay();
    var n = S.moves.length % 2 === 0 ? 2 : 1;
    if (S.moves.length < n) return;
    S.moves.length -= n;
    S.pos = boardAt(S.moves.length);
    S.ended = false;
    S.winner = 0;
    S.resigned = false;
    S.sel = -1; S.selMoves = [];
    S.hint = null;
    S.flyMove = null; S.flyFresh = false;
    S.reviewAt = S.moves.length - 1;
    save();
    renderAll();
  }

  function hint() {
    if (S.busy || S.ended || S.reviewAt < S.moves.length - 1) return;
    stopReplay();
    var r = think(S.pos, 2);            // 按进阶口径给提示
    if (!r) return;
    var an = annotate(S.pos, r.move);
    S.hint = { f: r.move.f, t: r.move.t };
    S.sel = -1; S.selMoves = [];
    renderAll();
    ui.status.textContent = '提示：' + an.san + '（' + an.from + '-' + an.to + '） —— '
      + an.phrases.join('；') + '。不是唯一好棋，供参考。';
  }

  function resign() {
    if (S.ended || S.busy) return;
    stopReplay();
    S.ended = true;
    S.winner = 2;
    S.resigned = true;
    bumpRecord('l');
    save();
    renderAll();
  }

  /* ============ 强度与音效选择器 ============ */

  function bindPicker(container, attr, getVal, setVal) {
    var btns = container.querySelectorAll('[data-' + attr + ']');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          setVal(b.getAttribute('data-' + attr));
          for (var j = 0; j < btns.length; j++) {
            var on = btns[j] === b;
            btns[j].classList.toggle('is-active', on);
            btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
        });
      })(btns[i]);
    }
    for (var k = 0; k < btns.length; k++) {
      var on = getVal() === btns[k].getAttribute('data-' + attr);
      btns[k].classList.toggle('is-active', on);
      btns[k].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  /* ============ boot ============ */

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.board = root.querySelector('[data-st-board]');
    ui.thinking = root.querySelector('[data-st-thinking]');
    ui.status = root.querySelector('[data-st-status]');
    ui.explain = root.querySelector('[data-st-explain]');
    ui.moves = root.querySelector('[data-st-moves]');
    ui.saved = root.querySelector('[data-st-saved]');
    ui.evalFill = root.querySelector('[data-st-eval-fill]');
    ui.evalNum = root.querySelector('[data-st-eval-num]');
    ui.material = root.querySelector('[data-st-material]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.replayBtn = root.querySelector('[data-st-replay]');
    ui.replayLabel = root.querySelector('[data-st-replay-label]');
    ui.undoBtn = root.querySelector('[data-st-undo]');
    ui.hintBtn = root.querySelector('[data-st-hint]');
    ui.resignBtn = root.querySelector('[data-st-resign]');
    ui.prevBtn = root.querySelector('[data-st-prev]');
    ui.nextBtn = root.querySelector('[data-st-next]');
    ui.exportBtn = root.querySelector('[data-st-export]');
    ui.copyBtn = root.querySelector('[data-st-copy]');
    ui.reviewBtn = root.querySelector('[data-st-review]');

    var had = restore();
    buildBoard();

    bindPicker(root.querySelector('[data-st-level-picker]') || root, 'st-level',
      function () { return String(S.level); },
      function (v) { S.level = parseInt(v, 10) || 1; });
    bindPicker(root.querySelector('[data-st-sound-picker]') || root, 'st-sound',
      function () { return S.soundOn ? 'on' : 'off'; },
      function (v) { S.soundOn = v === 'on'; });

    ui.newBtn.addEventListener('click', newGame);
    ui.replayBtn.addEventListener('click', toggleReplay);
    ui.undoBtn.addEventListener('click', undo);
    ui.hintBtn.addEventListener('click', hint);
    ui.resignBtn.addEventListener('click', resign);
    ui.prevBtn.addEventListener('click', function () { stopReplay(); if (S.reviewAt > 0) { S.reviewAt--; S.sel = -1; S.selMoves = []; S.hint = null; S.flyMove = null; S.flyFresh = false; renderAll(); } });
    ui.nextBtn.addEventListener('click', function () { stopReplay(); if (S.reviewAt < S.moves.length - 1) { S.reviewAt++; S.flyMove = null; S.flyFresh = false; renderAll(); } });
    ui.exportBtn.addEventListener('click', exportText);
    ui.copyBtn.addEventListener('click', copyText);
    ui.reviewBtn.addEventListener('click', handoffReview);

    renderAll();
    if (had) toast('已恢复上次没下完的这局');
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STXiangqi = {
    FILES: FILES, PIECE_CHAR: PIECE_CHAR, TYPE_NAME: TYPE_NAME, TYPE_VALUE: TYPE_VALUE,
    LEVELS: LEVELS, RED: RED, BLACK: BLACK, MATE: MATE, DRAW_HALF: DRAW_HALF,
    startBoard: startBoard, newPos: newPos,
    genPseudo: genPseudo, attacked: attacked, kingsFacing: kingsFacing,
    legalMoves: legalMoves, applyMove: applyMove, undoMove: undoMove, inCheck: inCheck,
    evaluateNum: evaluateNum, evaluateParts: evaluateParts,
    think: think, bestMove: bestMove, pvLine: pvLine, annotate: annotate, toChinese: toChinese,
    coordOf: coordOf, coordIndex: coordIndex, inPalace: inPalace, crossed: crossed,
    exportLines: exportLines, sideName: sideName, pieceName: pieceName
  };
})(typeof window !== 'undefined' ? window : globalThis);
